<script lang="ts" setup>
import { useUserStore } from "@/stores/userStore";
import { computed, ref } from "vue";
import ThePlus from "@/assets/icons/plus.svg";
import TheMinus from "@/assets/icons/minus.svg";

const userStore = useUserStore();

const levels = computed(() => userStore.user.vip.grid);

const currentLevel = computed(() => {
    return levels.value.reduce((acc, item) => {
        if (item.level === userStore.user.vip.level) {
            return item
        };
        return acc;
    }, {level: 0, sum: 0, percent: 0})
})
const nextLevel = computed(() => {
    return levels.value.reduce((acc, item) => {
        if (item.level === userStore.user.vip.level + 1) {
            return item
        };
        return acc;
    }, null)
})

const currentProgress = computed(() => {
    return nextLevel.value ? (userStore.user.vip.history_sum_paid - currentLevel.value.sum) / (nextLevel.value.sum - currentLevel.value.sum) : 1;
})



const props = defineProps<{
    isModalOpen: boolean
}>()

const isAccordionOpen = ref(false);

const emit = defineEmits(["modalClose"]);
</script>
<template>
<div class="fixed top-[92px] left-0 w-full bottom-0 z-10">
    <div class="max-w-[500px] h-full mx-auto p-4 flex flex-col overflow-y-auto bg-white-pure dark:bg-black">
        <div class="rounded-full border-2 b dark:border-primary border-blue w-[108px] h-[108px] flex flex-col items-center justify-center text-center mx-auto shrink-0">
            <span class="text-[48px] font-semibold leading-none text-primary dark:text-white">
                {{ userStore.user.vip.level }}
            </span>
            <span class="mt-1 text-black text-opacity-60 dark:text-white dark:text-opacity-60 text-[16px] leading-[12px]">
                lvl
            </span>
        </div>
        <div class="mt-4 flex justify-between items-center gap-x-2">
            <span class="bg-grey-light dark:bg-black-light rounded-full py-2 px-2.5 text-[13px] leading-[12px]">{{ currentLevel.percent.toFixed(1).replace('.',',') }}<sup class="text-[0.6em]">%</sup></span>
            <div class="bg-blue-light grow h-3 rounded-full relative overflow-hidden">
                <span class="absolute h-full right-full top-0 rounded-full w-full bg-primary" :style="{right: (100 - 100 * currentProgress) + '%'}"></span>
            </div>
            <span class="bg-grey-light dark:bg-black-light rounded-full py-2 px-2.5 text-[13px] leading-[12px]">{{ (nextLevel ? nextLevel.percent : currentLevel.percent).toFixed(1).replace('.',',') }}<sup class="text-[0.6em]">%</sup></span>
        </div>
        <p class="mt-0.5 text-center text-black dark:text-white leading-none text-[13px]">{{ userStore.user.vip.history_sum_paid }}&nbsp;₽ / {{ nextLevel ? nextLevel.sum : levels.at(-1).sum }}&nbsp;₽</p>
        <p class="mt-7 pt-7 dashed-border text-[13px] text-black text-opacity-60 dark:text-white dark:text-opacity-60">
            Ваша текущая скидка составляет <span class="text-black dark:text-white">{{ currentLevel.percent.toFixed(1).replace('.',',') }}%</span>.
            <span v-if="nextLevel">Пополните баланс Steam <span class="text-black dark:text-white">на&nbsp;{{nextLevel.sum - userStore.user.vip.history_sum_paid}}&nbsp;₽</span>, чтобы перейти на следующий уровень и увеличить скидку.</span>
            <span v-else>Вы достигли максимального уровня!</span>
        </p>
        <button @click="emit('modalClose')" class="mt-7 text-white bg-primary rounded p-3 text-center text-[15px] font-semibold w-full">Пополнить баланс</button>
        <div class="mt-7 rounded bg-primary bg-opacity-10 dark:bg-blue-dark dark:bg-opacity-40 p-3">
            <button @click="isAccordionOpen = !isAccordionOpen" type="button" class="text-black dark:text-white text-[13px] flex justify-between gap-x-4 w-full items-center">
                Подробнее о скидках
                <ThePlus width="16" height="16" v-if="!isAccordionOpen" />
                <TheMinus width="16" height="16" v-else />
            </button>
            <div :class="[
                'text-black text-opacity-60 dark:text-white dark:text-opacity-60 text-[13px] leading-[12px] overflow-hidden duration-500 ease-in-out',
                {'max-h-0 -translate-y-3 opacity-0': !isAccordionOpen},
                {'max-h-[500px] translate-y-0 opacity-100': isAccordionOpen},
            ]">
                <div class="pt-6">
                    <div class="flex justify-between gap-x-4 items-start">
                        <span>Уровень</span>
                        <span>Скидка</span>
                    </div>
                    <div class="mt-4 pt-4 flex flex-col gap-y-4 border-t border-black border-opacity-10 dark:border-white dark:border-opacity-10">
                        <div v-for="level in levels" class="flex justify-between gap-x-4 items-start text-black dark:text-white">
                            <span>{{ level.level }} lvl</span>
                            <span>{{ level.percent.toFixed(1).replace('.', ',') }}<sup class="text-[0.6em]">%</sup></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>
</template>

<style>
</style>
